module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ata"
    }
  })]), _c('a', {
    attrs: {
      "id": "ata"
    }
  }), _c('div', {
    staticClass: "fmtx1"
  }, [_c('a', {
    attrs: {
      "id": "ata"
    }
  }, [_c('b', [_vm._v("Tom Holt")]), _vm._v(" was born in London in 1961. At Oxford he studied bar billiards, ancient Greek agriculture and the care and feeding of small, temperamental Japanese motorcycle engines; interests which led him, perhaps inevitably, to qualify as a solicitor and emigrate to Somerset, where he specialised in death and taxes for seven years before going straight in 1995. Now a full-time writer, he lives in Chard, Somerset, with his wife, one daughter and the unmistakable scent of blood, wafting in on the breeze from the local meat-packing plant. For more information about Tom Holt visit ")]), _c('a', {
    attrs: {
      "href": "http://www.tom-holt.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tom-holt.com")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Find out more about other Orbit authors by registering for the free monthly newsletter at "), _c('a', {
    attrs: {
      "href": "http://www.orbitbooks.net",
      "target": "_blank"
    }
  }, [_vm._v("www.orbitbooks.net")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef3821f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tomh_9780748113576_oeb_ata_r1.vue
// module id = 60
// module chunks = 0